import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from '@angular/common/http';
import { finalize, Observable } from 'rxjs';
import { LoadingService } from '../../common/services/loading/loading.service';
import { RecordingService } from 'src/app/common/components/speech-to-text/recording.service';
import { VoiceCommandService } from 'src/app/business/voice-command/voice-command.service';
import { IdScanService } from 'src/app/common/components/id-scan/id-scan.service';
import { MfaService } from 'src/app/common/components/mfa/mfa.service';

@Injectable()
export class LoadingInterceptor implements HttpInterceptor {

  private bypassList: string[];

  constructor(private loader: LoadingService) {
    this.bypassList = [
      RecordingService.API_SPEECH_TO_TEXT,
      VoiceCommandService.API_PERFORM_CHAT,
      IdScanService.API_ID_SCAN_STATUS,
      IdScanService.API_ID_SCAN_POLL,
      MfaService.API_APP_AUTH_PROCESS
    ];
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    // Whether we show the loading icon or not
    if (!this.shouldIntercept(request)) return next.handle(request);

    this.loader.httpStart();
    return next.handle(request).pipe(
      finalize(() => {
        this.loader.httpEnd();
      })
    );
  }

  /**
   * Override the loader for specific requests
   */
  private shouldIntercept(request: HttpRequest<unknown>): boolean {
    return !this.bypassList.some(url => request.url.includes(url));
  }

}
